<template>
    <el-card class="mini-box-card box-d-card" >
        <template class="mini-card-header" #header>
            <span>Traveller Detail</span>

        </template>
        <h5>{{enquiry.name}}</h5>
        <ul class="ml-0 mb-0 fa-ul text-muted">

            <li class="small">Phone : {{enquiry.mobile}}</li>
            <li class="small">Email : {{enquiry.email_id}}</li>
            <li class="small">City : {{enquiry.city}}</li>
            <li class="small">State : {{enquiry.state}}</li>

        </ul>
    </el-card>


</template>

<script>
import {
    ElCard,ElTag,ElRow,ElCol,ElButton,ElSelect,ElOption
} from 'element-plus'

export default {
    name: "TravellerDetailsInfo",
    props: {
        enquiry: {
            type: Object,
            default() {
                return null
            }
        }
    },
    components: { ElSelect,ElOption,ElCard,ElTag,ElRow,ElCol,ElButton },
    data() {
        return {

        }
    },
    created(){

    },
    methods:{
    }
}
</script>

<style scoped>

</style>
